<script>
import { h } from 'vue'
import { authApi } from 'api'
export default {
  // Vue 3 no longer passes `h` (createElement) as an argument to `render()` — it must be
  // imported directly from 'vue'. This route renders nothing; it only performs the token
  // exchange + redirect below.
  render () {
    return h('div')
  },
  created () {
    this.$nextTick(() => {
      if (this.$route.query.jwt) {
        const bookId = this.$route.query.bookId
        const jwtRedirect = this.$route.query.redirect
        authApi.getTokenWithBookId(bookId, this.$route.query.jwt)
          .then(token => {
            this.$store.dispatch('setLoginOrigin', 'jwt')
            this.$store.dispatch('setToken', token)
            const dest = jwtRedirect && jwtRedirect !== 'undefined' ? jwtRedirect : '/book/' + bookId
            this.$router.replace(dest)
          })
          .catch(() => this.$router.replace('/loading'))
        return
      }

      if (this.$route.query.token) {
        this.$store.dispatch('setToken', this.$route.query.token)
        const redirect = this.$route.query.redirect
        this.$router.replace(redirect && redirect !== 'undefined' ? redirect : '/book/' + this.$route.query.bookId)
        return
      }

      this.$router.replace('/noaccess')
    })
  }
}
</script>
